// src/components/Team/userCard/UserArrayPreview.jsx
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import styles from "./UserArrayPreview.module.scss";

import { BiMailSend } from "react-icons/bi";

const UserArrayPreview = ({
  user,
  users = [],
  displayRole,
  roleLabel = "—",
  inviteCount = 0,
  usersCount = 0,
  onToggle,
  onInviteClick,
}) => {
  const { t } = useTranslation();

  // ✅ liste des utilisateurs à afficher (max 3), fallback sur le user unique
  const list = useMemo(() => {
    if (Array.isArray(users) && users.length > 0) return users.slice(0, 3);
    return user ? [user] : [];
  }, [users, user]);

  const remainingUsers = useMemo(() => {
    const total = Number.isFinite(usersCount) ? usersCount : list.length;
    return Math.max(0, total - list.length);
  }, [usersCount, list.length]);

  if (list.length === 0) return null;

  const roleFor = (id) =>
    typeof displayRole === "function" ? displayRole(id) : roleLabel;

  return (
    <div className={styles.containerTeam}>
      <div className={styles.headerRow}>
        <h3>{t("team.my_team")}</h3>
      </div>

      <div className={styles.usersSection}>
        <div className={styles.usersList}>
          {list.map((u) => {
            const title =
              u?.display_name || u?.user_login || t("team.user_default");
            const subtitle = u?.user_email || "—";

            return (
              <div key={u?.ID ?? title} className={styles.userRow}>
                <div className={styles.titleBlock}>
                  <h4 className={styles.username} title={title}>
                    {title}
                  </h4>
                  <div className={styles.subInfo} title={subtitle}>
                    {subtitle}
                  </div>
                </div>

                <div className={styles.rowMeta}>
                  <span className={styles.rolePill}>{roleFor(u?.ID)}</span>
                  <span className={styles.idText}>ID: {u?.ID ?? "—"}</span>
                </div>
              </div>
            );
          })}
        </div>

        {(remainingUsers > 0 || inviteCount > 0) && (
          <div className={styles.moreWrapper}>
            <div className={styles.moreHint}>
              {remainingUsers > 0
                ? t("team.other_users", { count: remainingUsers })
                : t("team.no_other_user")}
              {inviteCount > 0 && (
                <>
                  {" • "}
                  {t("team.pending_invitations", { count: inviteCount })}
                </>
              )}
            </div>

            <button
              type="button"
              className={styles.moreBtn}
              onClick={onToggle}
            >
              {t("team.show_my_team")}
            </button>
          </div>
        )}
      </div>

      <div className={styles.bottomActions}>
        <button
          type="button"
          className={styles.inviteBtn}
          onClick={onInviteClick || onToggle}
        >
          <BiMailSend className={styles.inviteBtnIcon} />
          <span>{t("team.invite_user")}</span>
        </button>
      </div>
    </div>
  );
};

export default UserArrayPreview;
